import React, { useEffect, useState, useRef } from "react";
import SwiperCore, { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import "./MemberStories.css";
import ImageFrame from "./ImageFrame";
import chevronLeft from "./assets/svg/chevron-left-large.svg";
import chevronRight from "./assets/svg/chevron-right-large.svg";
import arrowIcon from "./assets/svg/arrow.svg";
import defaultImage from "./assets/image.png";
import { Link } from "react-router-dom";

SwiperCore.use([Pagination]);

const BASE = "https://beszeljegyesulet.hu/wp/wp-json/wp/v2";
const CATEGORY_NAME = "Az én dadogásom";

const decodeEntities = (str) => {
  const txt = document.createElement("textarea");
  txt.innerHTML = str;
  return txt.value;
};

const getExcerpt = (post) => {
  const raw = post.excerpt?.rendered ?? "";
  const stripped = raw.replace(/<[^>]+>/g, "");
  const decoded = decodeEntities(stripped);
  return decoded.substring(0, 180) + "…";
};

const MemberStories = () => {
  const [posts, setPosts] = useState([]);
  const swiperRef = useRef(null);

  useEffect(() => {
    fetch(`${BASE}/categories?per_page=100`)
      .then((r) => r.json())
      .then((cats) => {
        const cat = cats.find(
          (c) => c.name === CATEGORY_NAME || c.slug === "az-en-dadogasom"
        );
        if (!cat) { console.warn("Category not found:", CATEGORY_NAME); return []; }
        return fetch(`${BASE}/posts?_embed&categories=${cat.id}&per_page=100`).then((r) => r.json());
      })
      .then((data) => { if (Array.isArray(data)) setPosts(data); })
      .catch((err) => console.error("MemberStories fetch error:", err));
  }, []);

  const pages = [];
  for (let i = 0; i < posts.length; i += 6) {
    pages.push(posts.slice(i, i + 6));
  }

  const handlePrev = () => {
    const swiper = swiperRef.current;
    if (!swiper) return;
    if (swiper.isBeginning) swiper.slideTo(swiper.slides.length - 1);
    else swiper.slidePrev();
  };

  const handleNext = () => {
    const swiper = swiperRef.current;
    if (!swiper) return;
    if (swiper.isEnd) swiper.slideTo(0);
    else swiper.slideNext();
  };

  const renderCard = (post) => {
    const featured =
      post._embedded?.["wp:featuredmedia"]?.[0]?.source_url || defaultImage;
    return (
      <div className="info-card" key={post.id}>
        <ImageFrame post={post} src={featured} alt={post.title.rendered} />
        <div className="info-content">
          <h3
            className="heading-md"
            dangerouslySetInnerHTML={{ __html: post.title.rendered }}
          />
          <p>{getExcerpt(post)}</p>
          <Link to={`/posts/${post.slug}`} className="info-link">
            Tovább{" "}
            <img src={arrowIcon} alt="nyíl ikon" className="arrow-icon" />
          </Link>
        </div>
      </div>
    );
  };

  return (
    <section className="latestinfo memberstories">
      <h2 className="heading-sm">Tagjaink történetei</h2>
      <div className="latestinfo-carousel">
        <button className="custom-nav ms-prev" aria-label="Előző" onClick={handlePrev}>
          <img src={chevronLeft} alt="" />
        </button>
        <button className="custom-nav ms-next" aria-label="Következő" onClick={handleNext}>
          <img src={chevronRight} alt="" />
        </button>
        <Swiper
          spaceBetween={24}
          slidesPerView={1}
          slidesPerGroup={1}
          loop={false}
          initialSlide={0}
          onSwiper={(swiper) => { swiperRef.current = swiper; }}
          pagination={{ el: ".memberstories-pagination", clickable: true }}
        >
          {pages.length === 0 ? (
            <SwiperSlide>
              <div className="memberstories-grid">
                <div className="info-card loading">Betöltés...</div>
              </div>
            </SwiperSlide>
          ) : (
            pages.map((page, i) => (
              <SwiperSlide key={i}>
                <div className="memberstories-grid">
                  {page.map((post) => renderCard(post))}
                </div>
              </SwiperSlide>
            ))
          )}
          <div className="swiper-pagination memberstories-pagination"></div>
        </Swiper>
      </div>
    </section>
  );
};

export default MemberStories;